// Image carousel wsith scrollbar
document.addEventListener("DOMContentLoaded", () => {
    // Gallery modal carousel
    if (document.querySelector(".image-carousel .swiper")) {
        let swiperGallery = new Swiper('.image-carousel .swiper', {
            allowTouchMove: true,
            slidesPerView: 'auto',
            // grabCursor: true,
            preventClicks: true,
            spaceBetween: 10,
            keyboardControl: true,
            noSwipingClass: 'caption-container',
            speed: 1000,
            // loop: true,
            // centeredSlides: false,
            // // roundLengths: true,



            pagination: {
                el: null
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragSize: 102,
                hide: false,
                snapOnRelease: false
            },
            // mousewheel: {
            //     enable: true
            // },

            keyboard: {
                enabled: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            breakpoints: {
                767: {
                    scrollbar: {
                        // hide: true
                    },
                    spaceBetween: 20,
                    // autoHeight: true,
                    centeredSlides: false,
                    // slidesOffsetAfter: 85
                    // slidesOffsetAfter: 100,
                }
            },
            on: {
                // reachEnd: function () {
                //     this.snapGrid = [...this.slidesGrid];
                //     console.log('end');
                // },

                // snapGridLengthChange:function(){
                //     if( this.snapGrid.length != this.slidesGrid.length ){
                //         this.snapGrid = this.slidesGrid.slice(0);
                //     }
                // },

            }
        });

        console.log('carousel');
    }

});



//
// slidesPerView: 'auto',
//     // slidesPerView: 1,
//     loop: false,
//     spaceBetween: 20,
//     allowTouchMove: true,
//     speed: 300,
//     freeMode: true,
//     mousewheel: true,
//
//     // pagination: {
//     //     el: '.swiper-pagination',
//     //     clickable: true,
//     // },
//
//     navigation: {
//     nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
// },
//
// scrollbar: {
//     el: '.swiper-scrollbar',
//         draggable: true,
// },
//
// breakpoints: {
//     700: {
//     }
// }